export default {
  component: () => import('./page.vue'),
  path: '/hotel/report/:batchId',
  name: 'hotel-report',
  meta: {
    title: '数据分析报告',
    auth: true,
    needPhone: false,
    wechat: {
      TimelineShare: false,
      baseAuth: true,
    },
  },
};
